import { STARTING_SETTINGS, type Menu, type MenuSetting } from '@lyrmo/shared';
import { useCallback } from 'react';
import type { ApiClient } from '../../api/client';
import { useAccountList, type AccountList } from './useAccountList';

/**
 * Which choices in one of the writer's menus, AI tools, tones, or saved instructions, are hidden
 * or pinned. `owner` is who's signed in: null for nobody, whose menus stay as everyone's start,
 * and undefined until that's known.
 */
export function useMenuSettings(
  client: Pick<ApiClient, 'listMenuSettings'>,
  owner: string | null | undefined,
  menu: Menu,
): AccountList<MenuSetting> {
  const load = useCallback(() => client.listMenuSettings(menu), [client, menu]);
  const list = useAccountList(load, owner);
  return owner === null ? { ...list, items: STARTING_SETTINGS[menu] } : list;
}
